import { MapPin, Mail, Phone, Clock } from 'lucide-react';
import SEOHead from '../components/SEOHead';
import LeadForm from '../components/LeadForm';

export default function ContactPage() {
  return (
    <main data-testid="contact-page">
      <SEOHead
        title="Contact Us | Trademark Legal Forum - Get Expert Trademark Help"
        description="Contact Trademark Legal Forum for expert trademark registration, IP protection, and business services. Our team is ready to help protect your brand."
      />
      {/* Hero */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-32">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D1729] to-[#0A1128]" />
        <div className="container mx-auto px-6 md:px-12 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <p className="uppercase text-xs tracking-[0.2em] font-bold text-[#D4AF37] mb-4 font-['Outfit']">Contact Us</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white font-['Outfit'] tracking-tight leading-none mb-6">
              Take the Next Step <span className="gold-gradient-text">With Confidence</span>
            </h1>
            <p className="text-base md:text-lg text-[#A0AABF] leading-relaxed">
              Questions about trademark registration, copyright, or legal support? Connect with our team now for personalized guidance and secure your business and creative works effectively.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-20 md:py-32 bg-[#0A1128]">
        <div className="container mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <h2 className="text-2xl font-bold text-white font-['Outfit'] mb-8">We Are Here to Help</h2>
              <p className="text-[#A0AABF] leading-relaxed mb-8">
                Whether you are ready to file a trademark application, need legal advice on intellectual property matters, or simply want to learn more about our services, we would love to hear from you. Fill out the form and our team will get back to you within 24 hours.
              </p>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Mail size={20} className="text-[#D4AF37]" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold font-['Outfit'] text-sm mb-1">Email Us</h4>
                    <p className="text-[#A0AABF] text-sm">info@trademarklegalforum.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone size={20} className="text-[#D4AF37]" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold font-['Outfit'] text-sm mb-1">Call Us</h4>
                    <p className="text-[#A0AABF] text-sm">+1 (877) 787-8180	</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin size={20} className="text-[#D4AF37]" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold font-['Outfit'] text-sm mb-1">Visit Us</h4>
                    <p className="text-[#A0AABF] text-sm">1370 N St Andrews Pl, Los Angeles, CA 90028</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Clock size={20} className="text-[#D4AF37]" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold font-['Outfit'] text-sm mb-1">Business Hours</h4>
                    <p className="text-[#A0AABF] text-sm">Mon - Fri: 9:00 AM - 6:00 PM EST</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-[#121E3D] border border-[#1D2D50] rounded-sm p-8 md:p-10">
              <h3 className="text-xl font-bold text-white font-['Outfit'] mb-6">Send Us a Message</h3>
              <LeadForm isInline />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
